$(document).ready(function($){

	const _window = $(window);
	const windowWidth = _window.width();
	const windowHeight = _window.height();

	const html = $('html');
	const body = $('body');

	const responsive = 900 < windowWidth  ? false : true;
	const responsiveMobile = windowWidth <= 900;

	// 2.0 APP INIT
	function appInit() {
		initForms();
		initRetina();
	}
	appInit();

	// 3.0 UTILITY FUNCTIONS
	function initForms(){
		let inputs = $(`.field input[type="text"],
			.field input[type="email"], 
			.field input[type="tel"],
			.field input[type="url"],
			.field input[type="password"],
			.field textarea`);

		inputs.each(function() {
			let _this = $(this);

			if(_this.val().length > 0){
				_this.closest('.field').addClass('has_value');
			}
		}).blur(function() {
			let _this = $(this);

			_this.val() 
				? _this.closest('.field').addClass('has_value')
				: _this.closest('.field').removeClass('has_value');
		});
	}

	function initRetina(){
		if(window.devicePixelRatio > 1){
			html.addClass('is_retina');
		}
		if(responsiveMobile){
			$('img[data-responsive-mobile]').each(function() {
				var img = $(this);
				if(img.attr('responsive-mobile') != ''){
					img.attr('src',img.attr('data-mobile'))
				}
			});
		}
	}

	// 6.0 SCROLL ANIMATIONS USING ANIMATE.CSS

	// Check if element is scrolled into view
	function isScrolledIntoView(elem) {
		var docViewTop = $(window).scrollTop();
		var docViewBottom = docViewTop + $(window).height();

		var elemTop = $(elem).offset().top;
		var elemBottom = elemTop + $(elem).height() - 150;

		return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) || (elemBottom <= docViewBottom);
	}

	// simple subtle scroll affect as found on clara.co
	$(window).scroll(function() {
		$('.subtle-animation').each(function() {
			if (isScrolledIntoView(this) === true) {
				$(this).addClass(`in-view`);
			}
		});
	});
	setTimeout(function(){
		$('.subtle-animation').each(function() {
			if (isScrolledIntoView(this) === true) {
				$(this).addClass(`in-view`);
			}
		});
	}, 100);

	function displayNavigation() {
		const homepageNavigation = $('.section-navigation-bar').first();
		if (homepageNavigation.length) {
			const isStuck = homepageNavigation[0].getBoundingClientRect().top <= 0;
			const wasStuck = homepageNavigation.hasClass('is-stuck');
			homepageNavigation.toggleClass('is-stuck', isStuck);
			if (isStuck !== wasStuck) updateAudienceIndicator(homepageNavigation.find('[data-homepage-navigation]').first());
			$('.sticky-navigation').css('opacity', isStuck ? 1 : 0);
			return;
		}

		const selfLogo = $('.self-logo').first();
		if (!selfLogo.length) return;
		const headerHeight = selfLogo.height() + selfLogo.offset().top + 5;
		const scrollFixed = $(window).scrollTop() / headerHeight - 1;
		$('.sticky-navigation').css({
			'opacity': scrollFixed
		});
	}
    if($('.self-logo').length || $('.section-navigation-bar').length){
        $(window).scroll(function(){
            displayNavigation($(this).scrollTop())
        });
        setTimeout(function(){
            // fixes inconsistent display on page load since mid-page can show scrollTop 0
            displayNavigation();
        }, 100);
    }

	function homepageSectionsFor(audience) {
		return $('[data-homepage-section]').filter(function() {
			const sectionCategory = String($(this).attr('data-section-category') || '');
			return !sectionCategory || sectionCategory === audience;
		});
	} 

	function initHomepageAudienceSlider(navigation) {
		const audienceNames = navigation.find('[data-audience]').map(function() {
			return String($(this).attr('data-audience') || '');
		}).get().filter(Boolean);

		function buildSlider(type, sectionSelector, wrapperSelector) {
			if($('[data-homepage-audience-slider="' + type + '"]').length) return;
			const wrappersByAudience = new Map();
			audienceNames.forEach(function(audience) {
				wrappersByAudience.set(audience, []);
			});

			$(sectionSelector).each(function() {
				const audience = String($(this).attr('data-section-category') || '');
				const wrapper = $(this).closest(wrapperSelector)[0];
				const wrappers = wrappersByAudience.get(audience);
				if(wrapper && wrappers && wrappers.indexOf(wrapper) === -1) wrappers.push(wrapper);
			});

			const allWrappers = Array.from(wrappersByAudience.values()).flat();
			if(!allWrappers.length || !allWrappers[0].parentNode) return;

			const slider = document.createElement('div');
			slider.className = 'homepage-audience-slider homepage-audience-slider--' + type;
			slider.setAttribute('data-homepage-audience-slider', type);
			const track = document.createElement('div');
			track.className = 'homepage-audience-slider__track';
			track.setAttribute('data-homepage-audience-track', '');
			slider.appendChild(track);
			allWrappers[0].parentNode.insertBefore(slider, allWrappers[0]);

			audienceNames.forEach(function(audience) {
				const panel = document.createElement('div');
				panel.className = 'homepage-audience-slider__panel';
				panel.setAttribute('data-homepage-audience-panel', audience);
				panel.setAttribute('aria-hidden', 'true');
				panel.inert = true;
				(wrappersByAudience.get(audience) || []).forEach(function(wrapper) {
					panel.appendChild(wrapper);
				});
				track.appendChild(panel);
			});

			if(type === 'intro') {
				const sourceLogo = track.querySelector('.self-logo');
				if(sourceLogo) {
					const staticLogo = sourceLogo.cloneNode(true);
					staticLogo.classList.add('homepage-intro-static-logo');
					staticLogo.removeAttribute('tabindex');
					slider.appendChild(staticLogo);
				}
			}

			if('ResizeObserver' in window) {
				slider.homepageAudienceResizeObserver = new ResizeObserver(function() {
					if(!slider.classList.contains('is-transitioning')) updateHomepageAudienceSliderHeight();
				});
				track.querySelectorAll('[data-homepage-audience-panel]').forEach(function(panel) {
					slider.homepageAudienceResizeObserver.observe(panel);
				});
			}
		}

		buildSlider('intro', '.section-intro [data-homepage-section]', '.section-intro');
		buildSlider('content', '.section-portfolio [data-homepage-section], .section-advisory [data-homepage-section]', '.section-portfolio, .section-advisory');
	}

	function updateHomepageAudienceSliderHeight(audience) {
		const activeAudience = audience || $('[data-homepage-navigation] [data-audience].active').attr('data-audience');
		$('[data-homepage-audience-slider]').each(function() {
			const panel = this.querySelector('[data-homepage-audience-panel="' + activeAudience + '"]');
			if(panel) this.style.height = panel.scrollHeight + 'px';
		});
	}

	function updateHomepageIntroLogo(audience) {
		const slider = $('[data-homepage-audience-slider="intro"]')[0];
		if(!slider) return;
		const staticLogo = slider.querySelector('.homepage-intro-static-logo');
		const sourceLogo = slider.querySelector('[data-homepage-audience-panel="' + audience + '"] .self-logo');
		if(!staticLogo || !sourceLogo) return;
		staticLogo.href = sourceLogo.href;
		const staticImage = staticLogo.querySelector('img');
		const sourceImage = sourceLogo.querySelector('img');
		if(staticImage && sourceImage) {
			staticImage.src = sourceImage.src;
			staticImage.srcset = sourceImage.srcset;
			staticImage.alt = sourceImage.alt;
		}
	}

	function updateAudienceIndicator(navigation) {
		const audiences = navigation.find('.homepage-navigation__audiences')[0];
		const activeButton = navigation.find('[data-audience].active')[0];
		if (!audiences || !activeButton) return;
		const audienceRect = audiences.getBoundingClientRect();
		const buttonRect = activeButton.getBoundingClientRect();
		audiences.style.setProperty('--audience-indicator-width', buttonRect.width + 'px');
		audiences.style.setProperty('--audience-indicator-x', buttonRect.left - audienceRect.left - audiences.clientLeft + 'px');
	}

	let homepageAudienceTransitionId = 0;
	let releaseHomepageHeightLock;

	function restoreHomepageScrollPosition(scrollTop) {
		const root = document.documentElement;
		const previousScrollBehavior = root.style.scrollBehavior;
		root.style.scrollBehavior = 'auto';
		window.scrollTo(window.pageXOffset, scrollTop);
		root.style.scrollBehavior = previousScrollBehavior;
	}

	function captureHomepageViewportState(preferredAnchor) {
		const navigationSection = $('.section-navigation-bar').first()[0];
		const referenceTop = navigationSection ? navigationSection.getBoundingClientRect().bottom : 0;
		const visibleSections = $('[data-homepage-section]').filter(function() {
			return $(this).is(':visible') && !$(this).closest('[data-homepage-audience-panel][aria-hidden="true"]').length;
		}).toArray();
		let anchorElement = preferredAnchor && $(preferredAnchor).is(':visible') ? preferredAnchor : null;

		if(!anchorElement) {
			const currentSection = visibleSections.find(function(section) {
				const rect = section.getBoundingClientRect();
				return rect.top <= referenceTop && rect.bottom > referenceTop;
			});
			const sharedSections = visibleSections.filter(function(section) {
				return !String($(section).attr('data-section-category') || '');
			});

			if(currentSection && !String($(currentSection).attr('data-section-category') || '')) {
				anchorElement = currentSection;
			} else {
				anchorElement = sharedSections.find(function(section) {
					return section.getBoundingClientRect().bottom > referenceTop;
				}) || sharedSections[sharedSections.length - 1] || currentSection || null;
			}
		}

		return {
			scrollTop: window.pageYOffset,
			anchorElement: anchorElement,
			anchorTop: anchorElement ? anchorElement.getBoundingClientRect().top : null
		};
	}

	function restoreHomepageViewportState(viewportState) {
		if(!viewportState) return;

		if(viewportState.anchorElement && $(viewportState.anchorElement).is(':visible')) {
			const currentAnchorTop = viewportState.anchorElement.getBoundingClientRect().top;
			restoreHomepageScrollPosition(window.pageYOffset + currentAnchorTop - viewportState.anchorTop);
			return;
		}

		restoreHomepageScrollPosition(viewportState.scrollTop);
	}

	function lockHomepageDocumentHeight() {
		if(releaseHomepageHeightLock) releaseHomepageHeightLock();

		const previousMinHeight = document.body.style.minHeight;
		const previousOverflowAnchor = document.documentElement.style.overflowAnchor;
		const lockedHeight = Math.max(
			document.documentElement.scrollHeight,
			document.body.scrollHeight,
			window.pageYOffset + window.innerHeight
		);
		let isReleased = false;

		document.body.style.minHeight = lockedHeight + 'px';
		document.documentElement.style.overflowAnchor = 'none';
		const release = function() {
			if(isReleased) return;
			isReleased = true;
			document.body.style.minHeight = previousMinHeight;
			document.documentElement.style.overflowAnchor = previousOverflowAnchor;
			if(releaseHomepageHeightLock === release) releaseHomepageHeightLock = null;
		};
		releaseHomepageHeightLock = release;
		return release;
	}

	function animateHomepageAudience(audience, viewportState, releaseHeightLock) {
		const transitionId = ++homepageAudienceTransitionId;
		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		const sliderStates = $('[data-homepage-audience-slider]').map(function() {
			const slider = this;
			const track = slider.querySelector('[data-homepage-audience-track]');
			const panels = track ? Array.from(track.querySelectorAll('[data-homepage-audience-panel]')) : [];
			const targetIndex = panels.findIndex(function(panel) {
				return panel.getAttribute('data-homepage-audience-panel') === audience;
			});
			return {
				slider: slider,
				track: track,
				panels: panels,
				targetIndex: targetIndex,
				targetPanel: panels[targetIndex],
				currentPanel: panels.find(function(panel) {
					return panel.getAttribute('aria-hidden') === 'false';
				})
			};
		}).get().filter(function(state) {
			return state.track && state.targetPanel && state.targetIndex >= 0;
		});

		if(!sliderStates.length) {
			if(releaseHeightLock) releaseHeightLock();
			return;
		}

		let fallbackTimer;
		let hasFinished = false;
		let anchorFrame;
		const transitionDuration = prefersReducedMotion ? 0 : 650;
		const primaryState = sliderStates.find(function(state) {
			return state.slider.getAttribute('data-homepage-audience-slider') === 'content';
		}) || sliderStates[0];

		sliderStates.forEach(function(state) {
			state.slider.classList.add('is-transitioning');
			state.panels.forEach(function(panel) {
				const isParticipating = panel === state.currentPanel || panel === state.targetPanel;
				panel.inert = !isParticipating;
				if(isParticipating) panel.setAttribute('aria-hidden', 'false');
			});
			state.slider.style.height = Math.max(state.currentPanel ? state.currentPanel.scrollHeight : 0, state.targetPanel.scrollHeight) + 'px';
			state.track.style.transitionDuration = transitionDuration + 'ms';
			state.track.getBoundingClientRect();
		});

		function stabilizeAnchor() {
			if(hasFinished) return;
			restoreHomepageViewportState(viewportState);
			anchorFrame = requestAnimationFrame(stabilizeAnchor);
		}

		function finishTransition() {
			if(hasFinished) return;
			hasFinished = true;
			clearTimeout(fallbackTimer);
			cancelAnimationFrame(anchorFrame);
			primaryState.track.removeEventListener('transitionend', onTransitionEnd);

			if(transitionId !== homepageAudienceTransitionId) {
				if(releaseHeightLock) releaseHeightLock();
				return;
			}

			sliderStates.forEach(function(state) {
				state.slider.classList.remove('is-transitioning');
				state.panels.forEach(function(panel, index) {
					const isActive = index === state.targetIndex;
					panel.setAttribute('aria-hidden', String(!isActive));
					panel.inert = !isActive;
				});
				state.slider.style.height = state.targetPanel.scrollHeight + 'px';
			});
			restoreHomepageViewportState(viewportState);

			if(releaseHeightLock) {
				const releaseViewportState = captureHomepageViewportState(viewportState && viewportState.anchorElement);
				releaseHeightLock();
				restoreHomepageViewportState(releaseViewportState);
				requestAnimationFrame(function() {
					restoreHomepageViewportState(releaseViewportState);
				});
			}
		}

		function onTransitionEnd(event) {
			if(event.target === primaryState.track && event.propertyName === 'transform') finishTransition();
		}

		if(prefersReducedMotion) {
			sliderStates.forEach(function(state) {
				state.track.style.transform = 'translate3d(-' + (state.targetIndex * 100) + '%, 0, 0)';
			});
			finishTransition();
			return;
		}

		primaryState.track.addEventListener('transitionend', onTransitionEnd);
		anchorFrame = requestAnimationFrame(stabilizeAnchor);
		requestAnimationFrame(function() {
			sliderStates.forEach(function(state) {
				state.track.style.transform = 'translate3d(-' + (state.targetIndex * 100) + '%, 0, 0)';
			});
		});
		fallbackTimer = setTimeout(finishTransition, 900);
	}

	function positionHomepageAudienceSlider(audience) {
		$('[data-homepage-audience-slider]').each(function() {
			const slider = this;
			const track = slider.querySelector('[data-homepage-audience-track]');
			const panels = track ? Array.from(track.querySelectorAll('[data-homepage-audience-panel]')) : [];
			const targetIndex = panels.findIndex(function(panel) {
				return panel.getAttribute('data-homepage-audience-panel') === audience;
			});
			if(!track || targetIndex < 0) return;

			track.style.transitionDuration = '0ms';
			track.style.transform = 'translate3d(-' + (targetIndex * 100) + '%, 0, 0)';
			panels.forEach(function(panel, index) {
				const isActive = index === targetIndex;
				panel.setAttribute('aria-hidden', String(!isActive));
				panel.inert = !isActive;
			});
			requestAnimationFrame(function() {
				track.style.transitionDuration = '';
			});
		});
		updateHomepageAudienceSliderHeight(audience);
	}

	function setHomepageAudience(audience) {
		const navigation = $('[data-homepage-navigation]').first();
		const categories = new Map();

		navigation.find('[data-audience]').each(function() {
			const isActive = $(this).attr('data-audience') === audience;
			$(this).toggleClass('active', isActive).attr('aria-pressed', String(isActive));
		});
		updateHomepageIntroLogo(audience);

		$('[data-homepage-section]').each(function() {
			const section = $(this);
			const sectionCategory = String(section.attr('data-section-category') || '');
			const isVisible = !sectionCategory || sectionCategory === audience;
			const isSliderSection = section.closest('[data-homepage-audience-panel]').length > 0;
			section.toggleClass('homepage-section-hidden', !isSliderSection && !isVisible);
			if(isSliderSection) section.removeAttr('aria-hidden');
			else section.attr('aria-hidden', String(!isVisible));
			section.find('[data-filter-item]').removeClass('hidden');

			if(!isVisible) return;

			const action = section.attr('data-subcategory-action') || 'filter';
			section.find('[data-section-categories] [data-category]').each(function() {
				const category = String($(this).attr('data-category') || '');
				const navigationAudience = String($(this).attr('data-navigation-audience') || '');
				if(!category || categories.has(category) || (navigationAudience && navigationAudience !== audience)) return;

				const anchorSelector = '[data-section-anchor="' + category + '"]';
				const anchor = section.filter(anchorSelector).add(section.find(anchorSelector)).first();
				categories.set(category, {
					label: $(this).text().trim(),
					action: action,
					target: anchor.length ? anchor.attr('id') : ''
				});
			});
		});

		const categoryBar = navigation.find('[data-homepage-categories]').empty();
		categories.forEach(function(item, category) {
			$('<button type="button" class="homepage-navigation__category" aria-pressed="false"></button>')
				.attr('data-category', category)
				.attr('data-category-action', item.action)
				.attr('data-category-target', item.target)
				.text(item.label)
				.appendTo(categoryBar);
		});
		categoryBar.scrollLeft(0);

		const firstCategory = categoryBar.find('[data-category]').first();
		if(firstCategory.length) activateHomepageSubcategory(firstCategory, false);

		const activeLabel = navigation.find('[data-audience].active').text().trim();
		navigation.find('[data-homepage-navigation-status]').text(activeLabel + ' selected');
		updateAudienceIndicator(navigation);
		displayNavigation();
	}

	function activateHomepageSubcategory(button, shouldNavigate) {
		const navigation = $('[data-homepage-navigation]').first();
		const audience = navigation.find('[data-audience].active').attr('data-audience');
		const category = String(button.attr('data-category') || '');
		const action = button.attr('data-category-action') || 'filter';

		navigation.find('[data-category]').removeClass('active').attr('aria-pressed', 'false');
		button.addClass('active').attr('aria-pressed', 'true');

		if(action === 'filter') {
			const filterSections = homepageSectionsFor(audience).filter('[data-subcategory-action="filter"]');
			filterSections.each(function() {
				$(this).find('[data-filter-item]').each(function() {
					const itemCategory = String($(this).attr('data-category') || '');
					$(this).toggleClass('hidden', category !== 'all' && itemCategory !== category);
				});
			});
			updateHomepageAudienceSliderHeight(audience);

			if(shouldNavigate && filterSections.length) {
				requestAnimationFrame(function() {
					const target = filterSections.first()[0];
					const navigationSection = $('.section-navigation-bar').first()[0];
					const navigationOffset = navigationSection ? navigationSection.getBoundingClientRect().height + 16 : 0;
					const targetTop = window.pageYOffset + target.getBoundingClientRect().top - navigationOffset;
					window.scrollTo({
						top: Math.max(0, targetTop),
						behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
					});
				});
			}
		}

		if(action === 'anchor' && shouldNavigate) {
			const targetId = button.attr('data-category-target');
			const target = targetId ? document.getElementById(targetId) : null;
			if(target) {
				const navigationSection = $('.section-navigation-bar').first()[0];
				const stickyDealsBar = document.querySelector('[data-deal-sticky-rail]');
				const navigationHeight = navigationSection ? navigationSection.getBoundingClientRect().height : 0;
				const stickyDealsHeight = category === 'deals' || !stickyDealsBar ? 0 : stickyDealsBar.getBoundingClientRect().height;
				const targetTop = window.pageYOffset + target.getBoundingClientRect().top - navigationHeight - stickyDealsHeight - 16;
				window.scrollTo({
					top: Math.max(0, targetTop),
					behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
				});
			}
		}

		navigation.find('[data-homepage-navigation-status]').text(button.text().trim() + ' selected');
	}

	$(document).on('click', '[data-homepage-navigation] [data-audience]', function() {
		const audience = $(this).attr('data-audience');
		const navigation = $('[data-homepage-navigation]').first();
		if($('[data-homepage-audience-slider]').hasClass('is-transitioning')) return;
		const currentButton = navigation.find('[data-audience].active').first();
		const currentAudience = currentButton.attr('data-audience');
		if(audience === currentAudience) return;
		const navigationSection = $('.section-navigation-bar').first()[0];
		const viewportState = {
			scrollTop: window.pageYOffset,
			anchorElement: navigationSection,
			anchorTop: navigationSection ? navigationSection.getBoundingClientRect().top : null
		};
		const releaseHeightLock = lockHomepageDocumentHeight();
		setHomepageAudience(audience);
		restoreHomepageViewportState(viewportState);
		requestAnimationFrame(function() {
			restoreHomepageViewportState(viewportState);
		});
		animateHomepageAudience(audience, viewportState, releaseHeightLock);
	});

	$(document).on('click', '[data-homepage-navigation] [data-category]', function() {
		activateHomepageSubcategory($(this), true);
	});

	function initHomepageNavigation() {
		const navigation = $('[data-homepage-navigation]').first();
		if(!navigation.length) return;
		initHomepageAudienceSlider(navigation);
		const activeAudience = navigation.find('[data-audience].active').attr('data-audience');
		const initialAudience = activeAudience || navigation.attr('data-default-audience') || 'venture-capital';
		setHomepageAudience(initialAudience);
		positionHomepageAudienceSlider(initialAudience);
	}

	initHomepageNavigation();
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(function() {
			updateAudienceIndicator($('[data-homepage-navigation]').first());
		});
	}
	$(window).on('resize', function() {
		updateAudienceIndicator($('[data-homepage-navigation]').first());
		updateHomepageAudienceSliderHeight();
		displayNavigation();
	});
	$(document).on('shopify:section:load shopify:section:reorder', function() {
		initHomepageNavigation();
	});
});
